import React from 'react';
import { X, ShieldAlert } from 'lucide-react';

export const LegalModal = ({ onClose }) => {
    return (
        <div className="fixed inset-0 z-[150] bg-black/90 backdrop-blur-md flex items-center justify-center p-4 animate-fade-in">
            <div className="bg-slate-950 border border-slate-800 w-full max-w-2xl rounded-2xl shadow-2xl flex flex-col max-h-[85vh]">
                
                {/* Header */}
                <div className="p-6 border-b border-slate-800 flex justify-between items-start bg-slate-900/50">
                    <div>
                        <h2 className="text-2xl font-bold text-white flex items-center gap-2">
                            <ShieldAlert className="w-6 h-6 text-orange-500" /> Terms & Disclaimers
                        </h2>
                        <p className="text-slate-400 text-sm mt-1">Last Updated: {new Date().getFullYear()}</p>
                    </div>
                    <button onClick={onClose} className="p-2 hover:bg-slate-800 rounded-full transition-colors text-slate-400 hover:text-white">
                        <X className="w-6 h-6" />
                    </button>
                </div>

                {/* Content - Scrollable */}
                <div className="p-8 overflow-y-auto text-slate-300 text-sm space-y-8 leading-relaxed">
                    
                    <section>
                        <h3 className="text-white font-bold text-base mb-2 uppercase tracking-wider">1. Educational Purpose Only</h3>
                        <p className="text-justify">
                            Four Elements Finance&trade; is an educational tool designed to assist users in organizing their finances. 
                            <strong className="text-white"> We are not financial advisors, accountants, or tax professionals. </strong> 
                            Nothing in this application constitutes professional financial advice, investment recommendations, or tax guidance.
                        </p>
                    </section>

                    <section>
                        <h3 className="text-white font-bold text-base mb-2 uppercase tracking-wider">2. No Investment Recommendations</h3>
                        <p className="text-justify">
                            The "Earth" (Assets) and "Air" (Vision) tabs allow you to input hypothetical return rates and asset allocations. 
                            These inputs are chosen solely by you. We do not recommend specific stocks, bonds, cryptocurrencies, or allocation strategies. 
                            Any graph, chart, or projection produced is a mathematical simulation based on your inputs, not a prediction of the future.
                        </p>
                    </section>

                    <section>
                        <h3 className="text-white font-bold text-base mb-2 uppercase tracking-wider">3. Limitation of Liability</h3>
                        <p className="text-justify">
                            By using this app, you agree that Four Elements Finance&trade; is not liable for any financial losses, damages, or decisions made based on the data presented here. 
                            You are responsible for verifying all calculations and consulting with a qualified professional before making major financial decisions.
                        </p>
                    </section>

                    <section>
                        <h3 className="text-white font-bold text-base mb-2 uppercase tracking-wider">4. Data Privacy</h3>
                        <p className="text-justify">
                            We value your privacy. Your data is stored via Google Firebase. While we implement standard security measures (like Firestore Rules), 
                            no online transmission is 100% secure. We do not sell your personal financial data to third parties.
                        </p>
                    </section>

                </div>

                {/* Footer */}
                <div className="p-6 border-t border-slate-800 bg-slate-900/50 text-center">
                    <button onClick={onClose} className="bg-emerald-600 hover:bg-emerald-500 text-white font-bold py-3 px-12 rounded-lg transition-colors shadow-lg shadow-emerald-900/20">
                        I Understand & Agree
                    </button>
                </div>
            </div>
        </div>
    );
};